import TwoSidedView from "../TwoSidedView";
import useSeasonDetails from "../../hooks/useSeasonDetails";

function SpendensummeBlock({ header, paragraph }) {
    const { data } = useSeasonDetails();
    const total = data?.["spendensumme-total"] || "";

    return (
        <div className="w-full m-auto text-blue-dark">
            {header && (
                <div className="text-2xl text-golden w-full font-bold">{header}</div>
            )}
            <div className="mt-8 mb-16">
                <TwoSidedView
                    left={
                        <div>
                            <div className="text-6xl md:text-7xl font-bold text-golden leading-tight">
                                {total} €
                            </div>
                            <div className="text-2xl mt-4">
                                Spenden seit Bestehen des Dresdner Entencups!
                            </div>
                        </div>
                    }
                    right={<div>{paragraph || ""}</div>}
                />
            </div>
        </div>
    );
}

export default SpendensummeBlock;
